import { TPoint } from '../../../points/points.model';
import { TColumn } from '../columns/column.model';
import { priorityOrder } from '../columns/property-sorting';
import { ESortOrder } from '../sort-order-enum';
import { sortTitle } from './sort-title';
import { sort } from './sorting';

export function sortPriority(
  firstPoint: TPoint,
  secondPoint: TPoint,
  sortColumns: Partial<TColumn>[],
  index: number,
): number {
  if (priorityOrder[firstPoint.priority] < priorityOrder[secondPoint.priority]) {
    return sortColumns[index].sortOrder === ESortOrder.ASC ? -1 : 1;
  } else if (priorityOrder[firstPoint.priority] > priorityOrder[secondPoint.priority]) {
    return sortColumns[index].sortOrder === ESortOrder.ASC ? 1 : -1;
  }

  if (sortColumns[index + 1]) {
    return sort(firstPoint, secondPoint, sortColumns, index + 1);
  } else {
    return sortTitle(firstPoint, secondPoint, sortColumns, index);
  }
}
